import React from "react";


function Footer() {
  return (
    <footer className="bg-layoutColor flex-row p-7">
      <ul>
        <li>Site crée par Skorol</li>
        <li>Mon portfolio : <a href="https://skoroll.github.io/portfolio/" target="_blank">https://skoroll.github.io/portfolio/</a></li>
      </ul>


    </footer>
  );
}

export default Footer;
